// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productDetailsVideosStyles } from "@pace/App/Widgets/ProductDetails/ProductDetailsVideos";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { css } from "styled-components";

productDetailsVideosStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 20px;
        flex-grow: 1;
    `,
};

productDetailsVideosStyles.title = {
    variant: "h3",
    css: css`
        margin: 0;
    `,
};

productDetailsVideosStyles.videosContainer = {
    gap: 22,
};

productDetailsVideosStyles.videoContainer = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
        gap: 12px;
        &&& {
            flex-basis: max-content;
        }
    `,
};

productDetailsVideosStyles.imageWrapper = {
    css: css`
        position: relative;
        border-radius: 4px;
        overflow: hidden;
        width: 100%;
        height: 180px;
        max-width: 340px;
    `,
};

productDetailsVideosStyles.videoTitle = {
    size: 14,
    weight: fontConfig.weight.bold,
    lineHeight: "16px",
    color: "text.main",
    css: css`
        max-width: 340px;
    `,
};